import { render, staticRenderFns } from "./Zapping.vue?vue&type=template&id=72bba7c5&scoped=true"
import script from "./Zapping.vue?vue&type=script&lang=js"
export * from "./Zapping.vue?vue&type=script&lang=js"
import style0 from "./Zapping.vue?vue&type=style&index=0&id=72bba7c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bba7c5",
  null
  
)

export default component.exports